var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3c8bd9;}.cls-2{fill:#fabc04;}.cls-3{fill:#34a852;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.7,33.16,35.57,19c-1.62-2.83-3.29-5.64-4.86-8.5A6.54,6.54,0,0,0,20.42,9a7.11,7.11,0,0,0-1.67,2.64,9.16,9.16,0,0,0-.29,1.74,6.79,6.79,0,0,0,.94,3.7l5.18,9c.16.27.29.53.44.79v0a.91.91,0,0,1,.15.23l7.15,12.41A6.51,6.51,0,1,0,43.7,33.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.58,26l-5.18-9a6.79,6.79,0,0,1-.94-3.7,9.16,9.16,0,0,1,.29-1.74,1.74,1.74,0,0,1-.11.18L9.27,28,7,32a.1.1,0,0,0,0,.05h0l.89-.8a6.51,6.51,0,0,1,10.41,3.95,6.85,6.85,0,0,1-.25,3.36s0,0,0,0l.06,0,4-6.87L25,26.84v0C24.87,26.56,24.74,26.3,24.58,26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.39,35.16A6.51,6.51,0,0,0,8,31.21l-.89.8h0c-.11,0-.09.12-.16.18-.18.29-.37.54-.52.82a6.28,6.28,0,0,0-.87,4.19,6.47,6.47,0,0,0,6,5.64,6.34,6.34,0,0,0,6.17-3.29c.16-.26.29-.52.43-.78a1.42,1.42,0,0,0,.05-.22s0,0,0,0A6.85,6.85,0,0,0,18.39,35.16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAds);
export default __webpack_public_path__ + "static/media/Icon-Ads.470f5cfb435a45517dd9ce59f2c8587f.svg";
export { ForwardRef as ReactComponent };